export default __webpack_public_path__ + "static/benifitImg-57f0e304bf5bcb117c518488d1d86e4f.png";